module.exports = Promise.all([__parcel__import__("3wfzL"), __parcel__import__("5UoVC")]).then(() => parcelRequire('4qady'));